import React from "react";
import classNames from "classnames";
import { Button } from "@design-system/Button/Button";
import { Separator } from "../../Separator/Separator";
import styles from "./FilterActionsFooter.module.scss";

interface FilterActionsFooterProps {
    selectedCount: number;
    deselectFunction: () => void;
    reverseFunction?: () => void;
    applyFunction?: () => void;
    disabled?: boolean;
    hideBorderAndPadding?: boolean;
}

export const FilterActionsFooter: React.FC<FilterActionsFooterProps> = ({
    selectedCount,
    deselectFunction,
    reverseFunction,
    applyFunction,
    disabled,
    hideBorderAndPadding = false,
}) => {
    const buttonsToDisplay: React.ReactNode[] = [];

    if (applyFunction) {
        buttonsToDisplay.push(
            <Button
                disabled={disabled}
                onClick={applyFunction}
                variant="secondary"
                size="sm"
            >
                Apply
            </Button>,
        );
    }

    if (reverseFunction) {
        buttonsToDisplay.push(
            <Button
                disabled={disabled}
                onClick={reverseFunction}
                variant="secondary"
                size="sm"
            >
                Reverse
            </Button>,
        );
    }

    if (selectedCount > 0) {
        buttonsToDisplay.push(
            <Button
                disabled={disabled}
                onClick={deselectFunction}
                variant="secondary"
                size="sm"
            >
                Deselect ({selectedCount})
            </Button>,
        );
    }

    if (buttonsToDisplay.length === 0) {
        return null;
    }

    return (
        <div
            className={classNames(styles.filterFooter, {
                [styles.hideBorderAndPadding]: hideBorderAndPadding,
            })}
        >
            {buttonsToDisplay.map((button, index) => (
                <div key={`${index}-button`}>
                    {button}
                    {index < buttonsToDisplay.length - 1 && (
                        <Separator orientation="vertical" />
                    )}
                </div>
            ))}
        </div>
    );
};
